import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroBillBatchPaymentForm', {
    headerText: 'Xero Batch Payment',
    saveAndSubmitRequestSuccess: 'The request is submitted for approval.',
    addBillsAttentionText:
        'Please notice that Xero batch payments can only include Bills in base currency of Organisation in Awaiting Payment (Approved) status. 200 bills are displayed at one time.',
});
